import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import CacheBuster from 'react-cache-buster';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'font-awesome/css/font-awesome.min.css';

import { router } from '#/routes';
import { useSentry, useSetupAxios } from '#/services';
import env from '../env.mjs';
import { version } from '../package.json';
import { ENABLE } from './utils';

function App() {
    const queryClient = new QueryClient();
    const isCacheBusterEnable = env.VITE_CACHE_BUSTER === ENABLE;

    useSetupAxios();
    useSentry();

    return (
        <QueryClientProvider client={queryClient}>
            <CacheBuster
                currentVersion={version}
                isEnabled={isCacheBusterEnable}
                isVerboseMode={false}
                metaFileDirectory={'.'}
            >
                <RouterProvider router={router} />
            </CacheBuster>
            <ToastContainer />
            <ReactQueryDevtools />
        </QueryClientProvider>
    );
}

export default App;
